import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridApi, GridOptions } from 'ag-grid-community';
import { AG_GRID_DEFAULT_OPTIONS, onlyLinkFollowingByIdButton } from '../../../../core/config/aggrid.default.config';
import { AppRoutes } from '../../../../shared/route-paths.const';
import { GastoDtoOut } from '../../../models/gasto.model';
import { ContabilidadGastoService } from '../../../services/contabilidad-gasto.service';

@Component({
  selector: 'app-gasto-list',
  standalone: true,
  imports: [CommonModule, RouterModule, AgGridAngular, MatIconModule],
  templateUrl: './gasto-list.component.html',
  styleUrl: './gasto-list.component.scss',
})
export class GastoListComponent implements OnInit {
  gastos: GastoDtoOut[] = [];
  gridApi!: GridApi;

  constructor(
    private readonly service: ContabilidadGastoService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.obtenerGastos();
  }

  gridOptions: GridOptions = {
    ...AG_GRID_DEFAULT_OPTIONS,
    onGridReady: (params) => (this.gridApi = params.api),
  };

  columnDefs: ColDef[] = [
    { field: 'id', headerName: 'ID' },
    { field: 'fechaAsientoContable', headerName: 'Fecha Asiento Contable', type: 'dateColumn' },
    { field: 'observaciones', headerName: 'Observaciones' },
    { field: 'validado', headerName: 'Validado', type: 'booleanColumn' },
    onlyLinkFollowingByIdButton(AppRoutes.CONTABILIDAD_ONDA.GASTOS),
  ];

  obtenerGastos(): void {
    this.service.obtenerGastos().subscribe({
      next: (data) => {
        this.gastos = data;
      },
      error: (err) => {
        console.error('GastoListComponent - Error:', err);
      },
    });
  }

  onRowDoubleClicked(event: any): void {
    this.router.navigate([`${AppRoutes.CONTABILIDAD_ONDA.GASTOS}/${event.data.id}`]);
  }

  createGasto(): void {
    this.router.navigate([AppRoutes.CONTABILIDAD_ONDA.GASTOS_NEW]);
  }

  goToGastosNoProcesables(): void {
    window.open(`${AppRoutes.CONTABILIDAD_ONDA.GASTOS}/facturas-no-procesables`, '_blank');
  }
}
